import MGR from '../interceptors/MgrPublic';
import MGRAPI from '../interceptors/MgrApi';

export const userReset = (data) => MGR.post('/users/reset', data);

export const recoverUpdate = (data) => MGR.put(`/users/password?recoveryToken=${data.recoveryToken}`, data);

export const userProfile = (data) => MGRAPI.put('/users', data);

export const getUserProfile = () => MGRAPI.get('/users/profile');

export const changeUserPassword = (data) => MGRAPI.post('/users/password', data);

export const clientProfile = (data) => MGRAPI.put('/clients', data);

export const getClientProfile = () => MGRAPI.get('/clients/profile');

export const activateNewWorkspaceUser = ({ token, ...data }) => MGR.post(`/users/token/${token}`, data);

export const getAvailableClients = () => MGRAPI.get('/users/clients');

export const userResendEmail = (id) => MGRAPI.post(`/users/${id}/send`);

export const userLock = (id) => MGRAPI.put(`/users/${id}/lock`);

export const userUnlock = (id) => MGRAPI.put(`/users/${id}/unlock`);

export const update = (id, data) => MGRAPI.put(`/users/${id}`, data);

export const searchUsers = (params) => MGRAPI.get('/users/search', { params });

export const updateSecondaryContact = (id) => MGRAPI.patch(`/users/${id}/contact`);

export const removeSecondaryContact = () => MGRAPI.delete('/users/secondary-contact');

export const getUsers = (params) => MGRAPI.get('/users/listAll', { params });

export const editUser = (userId, role) => MGRAPI.put(`users/${userId}/roles/${role}`);

export const deleteUser = (userId) => MGRAPI.delete(`users/${userId}`);

export const changeEnableMfa = (mfa, data) => MGRAPI.put(`/users/mfa/${mfa}`, data);

export const removeUserDevices = (userId) => MGRAPI.delete(`/users/${userId}/devices`);

export const unlockUser = (userId) => MGRAPI.put(`/users/${userId}/unlock`);

export const usersLoginLogs = (params) => MGRAPI.get('/users/login-logs', { params });

export const usersActivityLogs = (params) => MGRAPI.get('/users/activity-logs', { params });

export const activateNewUser = (token, data) => MGR.post(`/auth/signup/${token}`, data);
